import React, { Component, useState, useEffect} from 'react';
import { Grid, Typography, Paper, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ewbConfig } from 'config';

const styles = theme => ({
  paperRoot: theme.mixins.gutters({
    padding: theme.spacing(3),
  }),
  linkDecoration: {
    "& a": {
      textDecoration: "none",
    },
  },
  paperMargin: {
    marginTop: 30,
  },
  blockContent: {
    flexDirection: 'column',
    marginLeft: 20,
  },
  panelWidth: {
    width: "100%",
  },
});

function ShowHeader({classes}) {
  const [headerData, setHeaderData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        // Fetch Onsite
        const res = await fetch(ewbConfig.apiUrl + 'contactusheader');
        const json = await res.json();

        setHeaderData(json);
        setIsLoading(false);
      } catch (error) {
        console.log("error", error);
      }
    }

    fetchData();

  },[]);
  
  if (isLoading) {
    return(
      <p>Loading....</p>
    )
  }
  
  return (
    headerData.map((data, index) =>{
      return (
        <Paper elevation={1} className={classes.paperRoot} >
          <Typography color="primary" variant="h5" component="h3" paragraph dangerouslySetInnerHTML={{__html: data.header}} />
          <Typography variant="body1" component="p" dangerouslySetInnerHTML={{__html: data.copy}}/>
        </Paper>
      )
    })
  )
}

function ShowBottom({classes}) {
  const [findStoreData, setFindStoreData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        // Fetch Onsite
        const res = await fetch(ewbConfig.apiUrl + 'contactusfindstore');
        const json = await res.json();

        setFindStoreData(json);
        setIsLoading(false);
      } catch (error) {
        console.log("error", error);
      }
    }

    fetchData();

  },[]);
  
  if (isLoading) {
    return(
      <p>Loading....</p>
    )
  }
  
  return(
    findStoreData.map((data, index) =>{
      return (
        <Paper elevation={1} className={classNames(classes.paperMargin, classes.paperRoot)}>
          <Typography color="primary" variant="h5" component="h3" paragraph dangerouslySetInnerHTML={{__html: data.header}} />
          <Typography variant="body1" component="p" dangerouslySetInnerHTML={{__html: data.copy}}/>
        </Paper>
      )
    })
  )
}

function ShowContactList({classes}) {
  const [contactListData, setContactListData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        // Fetch Onsite
        const res = await fetch(ewbConfig.apiUrl + 'contactuscontactlist');
        const json = await res.json();

        setContactListData(json);
        setIsLoading(false);
      } catch (error) {
        console.log("error", error);
      }
    }

    fetchData();

  },[]);

  const handleChange = panel => (event, expanded) => {
      setExpanded(expanded ? panel : false)
  };
  
  if (isLoading) {
    return(
      <p>Loading....</p>
    )
  }
  
  return(
    <Grid container className={classNames(classes.paperMargin, classes.linkDecoration)}>
      {
        contactListData.map((data, index) =>{
          return (
            <ExpansionPanel expanded={expanded === `panel${index}`} onChange={handleChange(`panel${index}`)} className={classes.panelWidth}>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon color="primary" />} >
                <Typography variant="body1" component="h3" dangerouslySetInnerHTML={{__html: data.header}}/>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.blockContent}>
                <Typography  dangerouslySetInnerHTML={{__html: data.copy}}/>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          )
        })
      }
    </Grid>
  )
}

export default withStyles(styles, { withTheme: true })(class extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.paperRoot}>
        <ShowHeader classes={classes} />
        <ShowContactList classes={classes} />
        <ShowBottom classes={classes} />
      </div>
    );
  }
});
